[
  {
    "name": "Brie",
    "image": "assets/dogs/brie.png",
    "breed": "Golden Retriever",
    "color": "Dorado",
    "description": [
      "Golden Retriever de 1 año 9 meses es parte de la familia de los quesitos 🤍🧀🐾✨de corazón dulce y energía dorada ✨",
      "Brie nació para ser especial. Desde bebé, su historia ya tenía sabor a amor — literalmente. Su camada completa lleva nombres de quesos, en honor al amor de su mamá humana por ellos 🧀💛",
      "Y como era de esperarse… a ella le tocó el nombre más cremosito y tierno: Brie 🥰",
      "Curiosa, dulce y juguetona, Brie casi siempre anda cargando un peluche o juguete — es su forma favorita de decir “¿quieres jugar conmigo?” 🧸🐾",
      "Ama a los niños, correr en la grama, nadar, enlodarse sin remordimiento y hacer “zoomies” a velocidad de cohete 🚀🌿",
      "Le encanta comer hielo, helado… y bueno, si fuera por ella, toda la comida del mundo estaría en su plato. Su pelaje dorado claro brilla, pero más brilla su energía: ágil, alegre, receptiva y llena de cariño.",
      "Brie es parte fundamental del equipo emocional de Sinergia Dorada.",
      "Acompaña, consuela, ilumina — y también ayuda a otros perritos a socializar, dando ejemplo con su nobleza ✨🫶🏻",
      "Apapachos son su idioma.",
      "Amor es su esencia.",
      "Servicio es su propósito.",
      "Datos adorables:",
      "🛌 Se mete debajo de la cama deslizándose como profesional",
      "🛋️ Su spot favorito: el sillón de la sala",
      "🦭 Cuando quiere jugar… hace ruiditos de foquita",
      "🐾 Y nadie lleva un peluche en la boca con más orgullo que ella",
      "Brie no solo acompaña, Brie abraza el alma y llena los días de luz dorada.",
      "Se llama Brie, pero también la llaman, “ para Ya!” “ya no más” “dormite un ratito” 🤭"
    ],
    "instagram": "https://www.instagram.com/familiahausderlowen/"
  },
  {
    "name": "Duke",
    "image": "assets/dogs/duke.png",
    "breed": "Doberman",
    "color": "Cafe y Negro",
    "description": [
      "Tiene 3 años y 6 meses y fue adoptado cuando tenía alrededor de 1 año desde entonces recibe entrenamiento, que disfruta mucho, especialmente si hay premios de por medio 😄🐾.",
      "Le encanta correr, jugar con otros perros y ser el escapista en las atrapaderas, su cansancio es más físico que mental, porque nunca se cansa de moverse y disfrutar. Además, es un perrito muy social y cariñoso: le encanta conocer personas, que lo acaricien y dar amor por la vida 💚🐶.",
      "Duke es inteligente, curioso y siempre quiere acompañar a su hermanita Lena, de quien ha aprendido a equilibrar su energía con ternura.",
      "En cuanto a la comida, no le hace el feo a nada: disfruta desde plátano, pepino y apio hasta cualquier premio que le den 😋.",
      "Con su alegría, cariño y entusiasmo, Duke ha demostrado que el amor y la lealtad rompen cualquier prejuicio aunque pertenece a razas estigmatizadas, ha trabajado duro para demostrar que la verdadera esencia de un perro está en su alma, no en su apariencia. 🌟🐾"
    ],
    "instagram": "https://www.instagram.com/duchessdobermans/"
  },
  {
    "name": "Fontina",
    "image": "assets/dogs/fontina.png",
    "breed": "Golden Retriever",
    "color": "Dorado",
    "description": [
      "Su nombre hace honor a un delicioso queso porque, al igual que él, es agradable y le regala una felicidad extra a quienes la conocen, ¡especialmente a los niños y abuelos! 🧀 tiene 1 año y 9meses, empezó su entrenamiento desde los 3 meses, es noble y súper juguetona, es pura alegría 🥰 tiene unos ojos claros preciosos y un pelaje bello que provoca abrazarla, ama sus snacks de arándanos y, sobre todo, sus bananas congeladas (¡son su obsesión!).",
      "Disfruta sus croquetas de la manera más relajada posible: ¡acostada! Su posición favorita para dormir es patas para arriba (la señal de que está en total confianza). 💛",
      "Adora jugar con el agua y las largas caminatas al aire libre.",
      "Fontina es la prueba de que un perro no solo completa una familia, sino que le añade un sabor especial a la vida. 🫶🏻 ✨"
    ],
    "instagram": "https://www.instagram.com/fontina_love/"
  },
  {
    "name": "Gaia",
    "image": "assets/dogs/gaia.png",
    "breed": "Terra Nova",
    "color": "Negro",
    "birthdate": "28/06/2023",
    "description": [
      "Es una perrita muy dulce, juguetona y algo testaruda. Siempre saluda a sus personas favoritas con un abrazo o pidiendo que le rasquen la pancita. Su actividad favorita es molestar a sus hermanos gatitos y corretearlos por toda la casa. Ama sus juguetes, pero lo que más le gusta es que alguien quiera jugar y correr junto a ella. En los días calurosos disfruta morder cubitos de hielo y dormir junto a un ventilador o bajo el aire acondicionado.",
      "Es fan de los dulces 🍭 —cualquiera le encanta—, aunque sus favoritos son las gomitas, pese a que sus papás prefieren que coma frutitas. Es una perrita muy especial: ha estado en entrenamiento desde los tres meses y, aunque es muy lista, le gusta hacerse la desentendida con sus ejercicios y tareas.",
      "Si conoces a Gaia en persona, puedes estar seguro de que querrá que la saludes y la acaricies mucho. 🥰🫶🏻"
    ],
    "instagram": "https://www.instagram.com/gaia_newfy/"
  },
  {
    "name": "Ginger",
    "image": "assets/dogs/ginger.png",
    "breed": "Golden Retriever",
    "color": "Dorado",
    "description": [
      "Tiene 1 año y 7 meses, y desde los 3 meses recibe entrenamiento para ser parte de nuestras visitas. Es juguetona, social y la más cariñosa de la casa. 🐾",
      "Ama los niños, el yogurt y las blue berries, pero lo que más disfruta son las dates con su familia y las jornadas junto a Sinergia Dorada, donde reparte amor y colitas felices por donde pasa.",
      "Traviesa, dulce e increíblemente inteligente… así es Ginger, la perrita que conquista corazones en cada visita. 🐶💛"
    ],
    "instagram": "https://www.instagram.com/ginthegoldengirl/"
  },
  {
    "name": "Lena",
    "image": "assets/dogs/lena.png",
    "breed": "Doberman",
    "color": "Cafe",
    "description": [
      "Tiene 5 años y 3 meses y llego a la familia a los 2 meses de vida. Desde los 3 meses recibe entrenamiento, que disfruta mucho. 🌟",
      "Le encanta correr, jugar, los paseos en carro y compartir con quienes ama. Su verdadera pasión es el entrenamiento, y su cansancio suele ser más mental que físico, porque siempre da lo mejor de sí.",
      "Es una perrita muy observadora, amorosa y social; le gusta jugar con sus amigos, aunque también disfruta cuidar de su hermanito Duke. Sabe cuándo acercarse para dar cariño y cuándo respetar el espacio de los demás. En cuanto a la comida, disfruta casi todo, pero espera con ilusión pollito, pescado y atún 😋.",
      "Con los años ha desarrollado una serenidad y sabiduría únicas. Su corazón se gana con tiempo y sinceridad, demostrando que el amor verdadero no depende de la raza 💖"
    ],
    "instagram": "https://www.instagram.com/duchessdobermans/"
  },
  {
    "name": "Mohana",
    "image": "assets/dogs/mohana.png",
    "breed": "Golden Retriever",
    "color": "Dorado",
    "description": [
      "Es una golden retriever de 4 años que irradia calma y ternura en cada paso🥰. Desde los dos meses fue entrenada como perra de servicio emocional y hoy es una compañera ejemplar, tranquila, intuitiva y llena de luz.",
      "Le encanta salir a correr, sentir el viento en su rostro y hacer visitas donde regala sonrisas y tranquilidad, tiene un brillo especial: su pelaje dorado parece sol y sus ojos “chinos” siempre reflejan dulzura, empatía y una conexión profunda con quienes la rodean.",
      "Adora el queso, los helados y las frutas — y más aún si puede compartirlos después de una jornada de trabajo o juegos.",
      "Mohana no solo brinda apoyo emocional, también ayuda a enseñar a otros perros, guiándolos con paciencia y ejemplo. Es noble, protectora y sabia; una verdadera embajadora del amor incondicional. 🐾✨"
    ],
    "instagram": "https://www.instagram.com/familiahausderlowen/"
  },
  {
    "name": "Piñata",
    "image": "assets/dogs/pinata.png",
    "breed": "Bulldog Frances",
    "color": "Negro y Blanco",
    "description": [
      "Boston Terrier de 3 años, ha recibido entrenamiento desde los 6 meses; es un integrante muy pacífico y contemplativo de Sinergia Dorada. Noble y estoico, transmite calma con su sola presencia. Aunque es juguetón cuando la ocasión lo amerita, lo que más disfruta es dormir largas siestas, descansar tranquilamente y observar con serenidad todo lo que pasa a su alrededor. Y por supuesto sus treats de pollo, que idolatra.",
      "Su carácter tranquilo y pacífico lo convierte en un verdadero equilibrio dentro del equipo: siempre está dispuesto a acompañar en silencio, a escuchar con su mirada atenta y a recordarnos la importancia de la paciencia y la calma. Piñata es único porque combina la fuerza de su porte con la dulzura de un compañero noble, y es parte esencial de la energía positiva que cultivamos en Sinergia Dorada. 🥰💛"
    ],
    "instagram": "https://www.instagram.com/pinata_y_cardamomo/"
  }
]
